import type { Settlement } from '../engine/map/settlement';
import { recordProduced } from '../engine/map/settlement';
import { getGameConfig } from '../config/gameConfig';
import { getBuildingStorage, getEffectiveOutputCap } from '../engine/settlement/utils';

export function runGoldMineTick(settlement: Settlement): boolean {
    if (settlement.buildings.goldMine.qty <= 0 || settlement.jobs.goldMiners <= 0) {
        const hadWork = settlement.production.goldMine.progress.length > 0;
        settlement.production.goldMine.progress = [];
        return hadWork;
    }
    let changed = false;
    const config = getGameConfig();
    const outputCap = getEffectiveOutputCap(settlement, config, 'goldMine', 'goldOre');
    const storage = getBuildingStorage(settlement, 'goldMine');
    while (settlement.production.goldMine.progress.length < settlement.jobs.goldMiners) {
        settlement.production.goldMine.progress.push(0);
        changed = true;
    }
    while (settlement.production.goldMine.progress.length > settlement.jobs.goldMiners) {
        settlement.production.goldMine.progress.pop();
        changed = true;
    }

    if (settlement.regionResources.goldDeposit <= 0) return changed;

    const ticksPerOre = config.production.goldMine.ticksPerOre;
    for (let i = 0; i < settlement.production.goldMine.progress.length; i += 1) {
        if (settlement.regionResources.goldDeposit <= 0) break;
        if (outputCap <= 0 || outputCap - storage.goldOre < 1) break;
        settlement.production.goldMine.progress[i] += 1;
        if (settlement.production.goldMine.progress[i] >= ticksPerOre) {
            settlement.production.goldMine.progress[i] -= ticksPerOre;
            settlement.regionResources.goldDeposit = Math.max(
                0,
                settlement.regionResources.goldDeposit - 1,
            );
            storage.goldOre += 1;
            recordProduced(settlement, 'goldOre', 1);
            changed = true;
        }
    }

    return changed;
}
